import $ from 'jquery'
import Swiper from './utils/getSwiper'

async function init () {
  $('.portfolio-module').each(function () {
    $(this).find('.portfolio-slider-js').each(async function () {
      await initSlider($(this))
    })

    initTab($(this).find('.tab-container-navi'), $(this).find('.tab-container-portfolio'))
  })
}

function initTab (navi, portfolio) {
  let tabPortfolio

  const tabNavi = new Swiper(navi.get(0), {
    slidesPerView: 'auto',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    speed: 300,
    watchSlidesProgress: true,
    allowTouchMove: false,
    watchSlidesVisibility: true,
    watchOverflow: true,
    breakpoints: {
      992: {
        allowTouchMove: true,
      },
      768: {
        allowTouchMove: true,
        slideToClickedSlide: true
      },
      576: {
        allowTouchMove: true,
        centeredSlides: true,
        slideToClickedSlide: true
      }
    },
    on: {
      slideChange: function () {
        setTimeout(function () {
          setMobileActive()
        }, 300)
      }
    }
  })

  setPortfolioSlider()
  $(window).on('resizeend', function () {
    tabPortfolio.destroy(false, true)
    setPortfolioSlider()
  })

  function setPortfolioSlider () {
    tabPortfolio = new Swiper(portfolio.get(0), {
      autoHeight: true,
      slidesPerView: '1',
      centeredSlides: true,
      preloadImages: false,
      fadeEffect: {
        crossFade: true
      },
      speed: 0,
      effect: 'fade',
      allowTouchMove: false,
    })
    tabPortfolio.slideTo(navi.find('.swiper-slide.active').data('swiper-index'))
  }

  navi.find('.swiper-slide').each(function () {
    $(this).on('click', function () {
      const index = $(this).data('swiper-index')
      navi.find('.swiper-slide').removeClass('active')
      $(this).addClass('active')
      tabPortfolio.slideTo(index)
      if ($(window).width() > 576) {
        tabNavi.slideTo(index)
      }
    })
  })

  function setMobileActive (direction) {
    if ($(window).width() <= 576) {
      const index = navi.find('.swiper-slide-active').data('swiper-index')
      navi.find('.swiper-slide').removeClass('active')
      navi.find('.swiper-slide-active').addClass('active')
      tabPortfolio.slideTo(index)
    }
  }
}

async function initSlider (element) {
  await import(/* webpackChunkName: "slick" */ 'slick-carousel/slick/slick')
  const sliderNav = $(element).parent().find('.dot')
  $(element).slick({
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    cssEase: 'linear',
    arrows: false,
    dots: false,
    responsive: [{
      breakpoint: 992,
      settings: {
        centerPadding: '30vw',
      }
    }, {
      breakpoint: 768,
      settings: {
        centerPadding: '22vw',
      }
    }, {
      breakpoint: 576,
      settings: {
        centerPadding: '22vw',
      }
    }, {
      breakpoint: 575,
      settings: {
        centerPadding: '22vw',
      }
    }, {
      breakpoint: 450,
      settings: {
        centerPadding: '20vw',
      }
    }, {
      breakpoint: 320,
      settings: {
        centerPadding: '15vw',
      }
    }]
  })
  $(element).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    const slideCount = slick.slideCount
    if (nextSlide == 0) {
      $(this).find('[data-slick-index=' + slideCount + ']').addClass('next-active')
    } else {
      $(this).find('[data-slick-index=' + slideCount + ']').removeClass('next-active')
    }
  })

  indicator($(element), sliderNav)
}

function indicator (slider, sliderNav) {
  sliderNav.each(function () {
    $(this).on('click', function () {
      const id = $(this).data('slider-indicator')
      slider.slick('slickGoTo', id, false)
    })
  })

  slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    sliderNav.each(function () {
      $(this).removeClass('active')
      if ($(this).data('slider-indicator') === nextSlide) {
        $(this).addClass('active')
      }
    })
  })
}

export default {
  init
}
